<template>
    <div class="print aps">
        <p class="bold center">
ДОГОВОР НА ОКАЗАНИЕ ПЛАТНЫХ МЕДИЦИНСКИХ УСЛУГ №_____
        </p>
        <p style="text-align:left">
г. Якутск, {{ date }} г.
        </p>
        <p>
Общество с ограниченной ответственностью «Клиника Профессора», осуществляющее медицинскую деятельность на основании лицензии Л041-01179-14/00363652 от 25.06.2020 г. (выдана Министерством Здравоохранения Республики Саха (Якутия), именуемое в дальнейшем «Исполнитель и/или Клиника», в лице генерального директора Пальшина Геннадия Анатольевича, действующего на основании Устава, с одной стороны и гр.<br/>
        </p>
        <p>
Ф.И.О. {{ patient.full_name}}<br/>
        </p>
        <p>
Дата рождения {{ patient.birthdate }} г. В лице законного представителя ______________________________________________________________________(Ф.И.О.) с другой стороны, в дальнейшем именуемый (ая) «Заказчик и/или Пациент», с другой стороны, в дальнейшем совместно именуемые «Стороны», заключили настоящий Договор о нижеследующем:<br/>
        </p>
        <p>
1.Предмет Договора<br/>
        </p>
        <p>
1.1.Заказчик поручает, а Исполнитель обязуется  оказывать на возмездной основе необходимую медицинскую помощь (медицинские услуги, в том числе профилактическое, лечебно-диагностические, реабилитационные и др.), отвечающую требованиям, предъявляемым к методам диагностики, профилактики и лечения, разрешенным на территории РФ Пациенту: {{ patient.full_name }}, а Заказчик добровольно принимает на себя обязательство оплачивать оказанные медицинские услуги в порядке и на условиях, предусмотренных настоящим Договором, в соответствии с перечнем (прейскурантом)услуг Исполнителя и  установленными в нём ценами на услуги на дату их оказания.<br/>
        </p>
        <table class="rc-table aps-table">
            <tr>
                <th width="5%">
                    №
                </th>
                <th width="35%">
                    Наименование услуги
                </th>
                <th width="20%">
                    Срок оказания услуг (период, дата)
                </th>
                <th width="20%">
                    Специалист (Ф.И.О.)
                </th>
                <th width="20%">
                    Стоимость
                </th>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
            <tr>
                <td width="5%">
                </td>
                <td width="35%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
                <td width="20%">
                </td>
            </tr>
        </table>
        <p>
2. Общие положения
</p>
<p>
2.1. Перечень медицинских услуг, предоставляемых Заказчику, который определяется действующим на дату оказания услуг прейскурантом Исполнителя, а также документы и сведения, подтверждающие факт государственной регистрации 000 «Клиника Профессора» находятся в открытом доступе на информационном стенде Исполнителя и на сайте https://www.clinic professor.com. 
</p>
<p>
2.2. Настоящий договор оговаривает оказание медицинских услуг непосредственно Пациенту. 
</p>
<p>
2.3. Объём и срок предоставления (оказания) конкретных медицинских услуг, проведения лечения конкретизируются по соглашению с Заказчиком исходя из периода необходимого для выполнения предусмотренных регламентирующими медицинскую деятельность нормативными документами, общего соматического статуса Пациента, его психоэмоционального состояния, наличия у него и у врача свободного времени, остроты клинической ситуации. индивидуального реабилитационного периода. Количество необходимых приемов (период времени, в течение которого оказывается услуга), определяется индивидуально, в результате чего составляется ориентировочный План-график лечения с указанием наименования, количества и периодичности сеансов предоставления медицинских услуг.        
</p>
<p>
План-график согласовывается с Заказчиком и заносится в медицинскую карту пациента. получающего медицинскую помощь в амбулаторных условиях и в стационарных условиях. 
</p>
<p>
3. Права Пациента 
</p>
<p>
3.1. При обращении в Клинику Пациент имеет право на:
</p>
<p>
3.1.1. выбор врача, получение консультаций врачей-специалистов; 
</p>
<p>
3.1.2. выбор даты и времени визита к врачу-специалисту Клиники, включая перенос ранее согласованных даты и времени визита на иные, согласованные Сторонами, дату и время, при наличии объективной возможности со стороны Клиники: 
</p>
<p>
3.1.3. профилактику, диагностику, лечение, медицинскую реабилитацию в условиях. соответствующих санитарно-гигиеническим требованиям: 
</p>
<p>
3.1.4. облегчение боли, связанной с заболеванием и (или) медицинским вмешательством, доступными методами и не запрещенными на территории РФ лекарственными препаратами: 
</p>
<p>
3.1.5. на достоверную, своевременную и полную информацию о состоянии своего здоровья: 
</p>
<p>
3.1.6. защиту сведений, составляющих врачебную тайну: 
</p>
<p>
3.1.7. отказа от медицинского вмешательства. 
</p>
<p>
3.2. За реализацию прав Пациента в Клинике отвечает главный врач. 
</p>
<p>
4. Обязанности Пациента 
</p>
<p>
4.1. При обращении в Клинику Пациент обязан: письменном виде в целях оказания медицинских услуг; 
</p>
<p>
4.1.1. предоставить Клинике информированное добровольное согласие на медицинское вмешательство в 
</p>
<p>
4.1.2. принять оказанные услуги, строго выполнять назначения, предписания и рекомендации врача: 
</p>
<p>
4.1.3. соблюдать правила гигиены, порядок и режим, санитарные нормы во время нахождения в Клинике: 
</p>
<p>
4.1.4. уважительно относиться к другим Пациентам и посетителям Клиники, к медицинскому и обслуживающему персоналу Клиники, соблюдать общепринятые правила этики и поведения: 
</p>
<p>
4.1.5. заботиться о своем здоровье, гигиеническом состоянии; 
</p>
<p>
4.1.6. не осуществлять действия, влекущие за собой нарушение прав других граждан на охрану здоровья и благоприятную среду обитания: 
</p>
<p>
4.1.7. предоставить Клинике до оказания медицинских услуг полную информацию и имеющиеся документы (копии документов). касающиеся состояния своего здоровья, которыми он располагает на момент заключения договора оказания платных медицинских услуг и в течение его действия, а именно имеющие отношение к анамнезу жизни, анамнезу заболевания. информировать обо всех перенесенных ранее заболеваниях, включая хронические, инфекционные и венерические, перенесенных операциях, всех видах аллергических реакций и лекарственной непереносимости, имеющихся нервно-психических расстройствах (эпилепсия и проч.). вирусных гепатитах, сахарном диабете, имеющихся патологических и физиологических зависимостях (алкоголь, наркотики), имевшихся ранее и имеющихся заболеваниях крови (анемия и проч.), а также имевшихся длительных кровотечениях, переливаниях крови, ревматических заболеваниях, врожденных или приобретенных пороках сердца, сердечно СОСУДИСТЫХ заболеваниях (сердечная недостаточность. коронарная недостаточность, ишемическая болезнь сердца. гипертоническая болезнь. гипотоническая болезнь, инфаркт), иных сосудистых заболеваниях (инсульт, атеросклероз и проч.). наличии кардиостимулятора или протеза клапана сердца, наличии электронных и металлических имплантатах, наличии кровоостанавливающих клипс в сосудах головного мозга, наличии аппарата Илизарова, травмах, заболеваниях органов дыхания. придаточных пазух носа, иных особенностей анамнеза жизни и заболевания, требующихся для медицинского вмешательства. включая информацию о постоянно применяемых лекарственных, гомеопатических препаратах и биологически-активных добавках и др.:
</p>
<p>
4.1.8. согласовать План-график лечения, обозначенный в п. 2.3, настоящего Договора: 
</p>
<p>
4.1.9. являться на консультации, назначенные процедуры и профилактические осмотры вовремя. При невозможности 
</p>
<p>
4.1.10. оплатить стоимость медицинских услуг авансовым 100% платежом до их оказания. установленную настоящим явиться на консультацию, процедуру или осмотр предупредить Клинику (администратора или врача) не позднее, чем за одни сутки до начала консультации (процедуры. осмотра) в часы работы Клиники: Договором и прейскурантом на дату оказания услуг: 
</p>
<p>
4.1.11. сообщать врачу обо всех изменениях в деятельности его организма (самочувствие и видимые изменения), даже если Пациент считает, что эти изменения не влияют на оказание Клиникой медицинской услуги; 
</p>
<p>
4.1.12. пациент вправе письменно отказаться в любое время от получения медицинской услуги и получить внесенную авансом сумму с возмещением Клинике фактически оказанных медицинских услуг согласно действующему Прейскуранту на дату оказания услуг; 
</p>
<p>
4.1.13. предоставить Клинике разрешение привлекать для оказания медицинских услуг любого медицинского работника из персонала, а также иных внешних специалистов, необходимость в профессиональном мнении которых возникает во время проведения обследования, лечения. 
</p>
<p>
5. Права Клиники 
</p>
<p>
5.1. При осуществлении медицинской деятельности Клиника вправе: 
</p>
<p>
5.1.1. самостоятельно определять график работы врачей: 
</p>
<p>
5.1.2. отступить от запланированного графика лечения в случае опоздания Пациента и занятости врача, непосредственно осуществляющего лечение, а в случае опоздания Пациента на прием к врачу, более чем на 30 минут, отменить прием и/или 
</p>
<p>
5.1.3. заменить врача при наступлении объективной невозможности проводить лечение данным врачом-специалистом, а перенести его в другое время: также при необходимости направить Пациента для консультации к другим собственным врачам-специалистам или в иную медицинскую организацию: 
</p>
<p>
5.1.4. самостоятельно в лице врачей-специалистов осуществлять выбор тактики и методики лечения, метода анестезиологического пособия, подбор материалов и медикаментов, определять количество выполняемых рентгенологических снимков, проведение других диагностических. профилактических и лечебных мероприятий, при условии наличия необходимости их осуществления: 
</p>
<p>
5.1.5. производить назначение медицинских препаратов. как включенных в перечень жизненно необходимых и важнейших лекарственных препаратов для медицинского применения, так и медицинских препаратов не включенных в указанный перечень: 
</p>
<p>
5.1.6. рекомендовать Пациенту определенные материалы и (или) медикаменты, стоимость которых превышает аналогичные материалы (медикаменты) при наличии для их применения (использования) медицинских показаний и (или) большего лечебного эффекта: 
</p>
<p>
5.1.7. отказать Пациенту в оказании медицинских услуг в случае, если проведение процедуры невозможно, в связи с индивидуальными особенностями организма Пациента. Процедура может быть прекращена в целях сохранения здоровья Пациента. Решение о прекращении процедуры принимает врач специалист, непосредственно оказывающий услугу: 
</p>
<p>
5.1.8. отказать в предоставлении медицинских услуг Пациенту в случаях, если тот хотя бы дважды безосновательно отказался от назначений врачей-специалистов Клиники: 
</p>
<p>
5.1.9. отказать в продолжении оказания медицинской услуги в случаях нарушения Пациентом условий настоящего Договора с обязательной фиксацией отказа в лечении и причин такого отказа в медицинской документации. Отказ от продолжения лечения возможен только при формулировании врачебных рекомендаций по дальнейшему лечению и не его отказа допускается при наличии у пациента острой стадии состояния заболевания: 
</p>
<p>
5.1.10. получить от Пациента соответствующий документ об отказе от медицинского вмешательства в случае услуг, которые могли бы, по мнению Клиники, уменьшить или снять опасность для его здоровья. от 
</p>
<p>
6. Обязанности Клиники 
</p>
<p>
6.1. При оказании медицинских услуг Клиника обязана:
</p>
<p>
6.1.1. уважительно и гуманно относиться к Пациенту; 6.1.2. согласовать с Пациентом характер и объем оказания медицинских услуг; 
</p>
<p>
6.1.3. предоставить Пациенту услуги согласно Прейскуранту, качество которых соответствует современным достижениям медицинской науки, и не может быть ниже установленных стандартов качества и порядков оказания медицинской помощи: 
</p>
<p>
6.1.4. в полном объеме информировать Пациента, его поверенного или законного представителя о выявленном состоянии его здоровья с учетом согласия Пациента на получение данной информации и в соответствии с действующим законодательством: 
</p>
<p>
6.1.5. посредством открытого размещения документов на информационном стенде и на сайте Клиники ознакомить Пациента со своей Лицензией на оказание медицинских услуг, а также с иной информацией о Клинике, как об исполнителе медицинских услуг, по содержанию и в объеме, объективно позволяющей принять осознанное решение об обращении в Клинику, в том числе информацию о юридическом статусе, о режиме работы, контактный телефон, информацию о врачах и специалистах. непосредственно оказывающих медицинские услуги: 
</p>
<p>
6.1.6. давать Пациенту указания, носящие обязательный характер, предоставить Пациенту доступную и достоверную информацию о предоставляемой услуге: 
</p>
<p>
6.1.7. учитывая индивидуальные особенности Пациента, самостоятельно выбирать оздоровительные меры, необходимые Пациенту, а также согласовывать с Пациентом график посещений Клиники после проведенного лечения. 
</p>
<p>
6.1.8. отказать Пациенту в оказании медицинских услуг в случае отказа Пациента дать информированное добровольное согласие на медицинское вмешательство. 
</p>
<p>
7. Стоимость услуг и порядок расчётов 
</p>
<p>
7.1. Стоимость оказанных медицинских услуг, оказываемых по настоящему Договору. определяется в соответствии с утвержденным Исполнителем Прейскурантом медицинских услуг, действующим на дату оказания услуг. 
</p>
<p>
7.2. Оплата за услуги может производиться как самим Пациентом, так и его страховой компанией в случае наличия договорных отношений со страховой компанией на день оказания услуги и наличия гарантийного письма, администрацией по месту работы или другим заинтересованным лицом. 
</p>
<p>
7.3. Оплата стоимости медицинских услуг осуществляется Заказчиком авансовым 100% платежом до оказания медицинской услуги в рублях РФ путем внесения денежных средств в кассу Исполнителя или по безналичному расчету. путём перечисления денежных средств на расчетный счет Исполнителя, указанный в реквизитах. 
</p>
<p>
7.4. Стоимость услуг может быть увеличена по согласованию с Заказчиком в случае оказания Пациенту дополнительных медицинских услуг, в том числе и по просьбе Пациента. 
</p>
<p>
7.5. Окончательный расчет производится по факту оказания медицинских услуг. Если стоимость медицинских услуг меньше внесенного аванса, то остаток денежных средств возвращается Заказчику. 
</p>
<p>
</p>
<p>
8. Ответственность Сторон 
</p>
<p>
8.1. В случае ненадлежащего исполнения обязанностей по настоящему договору Исполнителем без вины Пациента. Исполнитель несёт ответственность в соответствии с действующим законодательством РФ. 8.2. Исполнитель не несет ответственности перед пациентом в случае если: 
</p>
<p>
8.2.1. проводилась коррекция назначенного лечения, оперативного вмешательства в другой клинике без согласия на то Исполнителя:
</p>
<p>
8.2.2. возникновения осложнений по вине Пациента (невыполнение назначений врача. несвоевременное сообщение о возникших отклонениях и нарушениях в состоянии здоровья и др.); 
</p>
<p>
8.2.3. лечение не завершено, но прекращено по инициативе Пациента. 
</p>
<p>
8.3. Исполнитель не несет ответственности за не достижение желаемого результата лечения, в том числе в случае неявки Заказчика в назначенные сроки для получения очередных сеансов лечения. При этом количество сеансов на курс может быть 
</p>
<p>
8.4. В случае неисполнения Пациентом медицинских указаний Исполнителя. Исполнитель вправе расторгнуть договор в увеличено. одностороннем порядке с отнесением фактически понесённых затрат на Пациента/Заказчика. 
</p>
<p>
8.5. Стороны освобождаются от ответственности за невыполнение или ненадлежащее выполнение обязательств по настоящему Договору, возникшее вследствие форс-мажорных обстоятельств, а именно: пожара, землетрясения, наводнения. катастроф. военных действий, решений органов государственной власти и суда, заболевания и иного патологического состояния. о которых стороны не знали и которые не были выявлены в процессе действия настоящего договора (выявление которых не предусмотрено стандартами и протоколами в медицине), а также обстоятельства, которые на современном уровне развития медицинской науки и практики не могут быть однозначно спрогнозированы, диагностированы и предотвращены, а также иных непреодолимых обстоятельств и их последствий, включая несогласованное отключение энергоснабжения, водообеспечения Исполнителя, если это не вызвано невыполнением Исполнителем обязательств по оплате соответствующих услуг. действует до 31 декабря текущего года. 
</p>
<p>
9. Срок действия договора 
</p>
<p>
9.1. Настоящий договор вступает в силу с момента его подписания сторонами и Если ни одна из сторон не уведомит письменно другую сторону о расторжении договора за 1 месяц до его истечения, то договор считается пролонгированным на тех же условиях на один календарный год. Количество пролонгаций не ограничено. 
</p>
<p>
9.2. При досрочном расторжении договора его условия продолжают действовать до полного исполнения сторонами своих обязательств. 
</p>
<p>
10. Заключительные положения 
</p>
<p>
10.1. Заключая настоящий договор. Пациент самостоятельно использует свое право на выбор платного оказания услуг при получении медицинской помощи на добровольной основе. в рамках договора оказания платных медицинских услуг. При этом Пациент уведомлен о возможности получения медицинской помощи в рамках Программы государственных гарантий бесплатного оказания гражданам медицинской помощи и территориальной Программы государственных гарантий бесплатного оказания гражданам медицинской помощи (ОМС) по месту прикрепления. 
</p>
<p>
</p>
<p>
10.2. При подписании настоящего договора Заказчик дает свое добровольное согласие на сбор, обработку. хранение. распространение и использование Исполнителем своих персональных данных, которые станут ему известны в процессе исполнения договора, в соответствии с Федеральным законом №152-ФЗ «О персональных данных». Все действия с персональными данными необходимы для исполнения предмета договора оказание медицинских услуг (п.1 договора) и требований законодательства РФ. 
</p>
<p>
10.3. В случае оплаты услуг по договору любым заинтересованным лицом (страховая компания, администрация по месту работы и т.д.). далее - Третья Сторона, Заказчик согласен на сбор, обработку, хранение и передачу Исполнителем своих персональных данных Третьей Стороне. Все действия с персональными данными необходимы для исполнения предмета договора - оказание медицинской услуги (п.1 договора).
</p>
<p>
10.4. На всех основных этапах оказания услуг, предусмотренных настоящим договором, до и после проведения медицинской услуги. Исполнитель выполняет фотофиксацию Пациента, для более достоверной оценки достигнутого результата. Фотографии являются собственностью Исполнителя и хранятся у Исполнителя, предназначены только для внутреннего использования. Исполнитель обязуется не размещать фотографии в СМИ без письменного согласия Пациента. 
</p>
<p>
10.5. Настоящий Договор составлен на русском языке в двух экземплярах, имеющих равную юридическую силу, один из которых находится у Исполнителя, второй - у Заказчика. 
</p>
<p>
10.6. B случаях, не предусмотренных настоящим договором, стороны руководствуются действующим законодательством РФ. 
</p>
<p>
10.7. Все изменения и дополнения к настоящему Договору вносятся в той же форме, что и сам Договор. и вступают в силу с момента подписания их обеими сторонами. 
</p>
<p>
10.8. При наличии разногласий сторон по настоящему Договору такие разногласия разрешаются путем направление второй стороне мотивированной претензии. Претензионный порядок по настоящему Договору обязателен. В случае не урегулирования разногласий в претензионном порядке, спор передается в суд согласно установленной гражданским законодательством территориальной подсудности его рассмотрения. 
</p>
<p>
10.9. В случае заключении с Заказчиком дополнительных соглашений, программ, приложений, такие документы считаются неотъемлемыми частями настоящего Договора и применяются в совокупности с его нормами.
</p>
<p>
10.10. Заказчик внимательно  ознакомился (ась) с действующим Прейскурантом услуг Исполнителя и  их стоимостью  и согласен(а) оплачивать все оказанные в последующем медицинские услуги в соответствии с настоящим Договором. Подписание настоящего договора со стороны Заказчика свидетельствует о получении им со стороны Исполнителя доступной, достоверной  и полной информации об Исполнителе медицинских услуг.
</p>
<p>
10.11 Экземпляр  настоящего Договора оказания платных медицинских услуг на руки получил 
</p>
<p>
________________________           (подпись  Пациента Заказчика)
</p>
<p>
11.11 Реквизиты сторон<br/>
<br/>
Исполнитель<br/>
ООО «Клиника Профессора»<br/>
ИНН  1435316805, КПП 143501001, ОГРН, 1171447001220<br/>
Адрес:677010, г. Якутск, ул.Радужная,69/12<br/>
р/с 40702810976000003855; к/с 30101810400000000609 БИК 049805609<br/>
телефон:+7(914)2776990<br/>
электронный адрес: Klinika.professora@mail.ru<br/>
Веб сайт:https://www.clinic-professor.com<br/>
<br/>
<br/>
Генеральный директор ООО «Клиника Профессора» _____________________/Пальшин Г.А./
</p>
<p>
Заказчик<br/>
<br/>
Пациент (законный представитель):{{ patient.full_name }} _______________/ФИО подпись пациента/<br/>
<br/>
Паспорт: {{ passport }}
</p>
    </div>
</template>
<script>
export default {
    props: ['patient','date'],
    computed: {
        passport() {
            if (this.$isJSON(this.patient.passport)) {
                let p = JSON.parse(this.patient.passport)
                return 'серия ' + p.series + ' номер ' + p.number + ' выдан ' + p.issued + ' ' + p.date
            }else{
                return this.patient.passport.length>0 ? this.patient.passport : 'не указаны'
            }
      }
    }
}
</script>